import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm sticky-top">
      <div className="container">
        {/* Brand */}
        <a className="navbar-brand fw-bold text-warning" href="#">
          MRDEVWORKS
        </a>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link active px-3" href="#">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#projects">
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#about">
                About
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#contact">
                Contact
              </a>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
}

export default Header;
